// node_modules
import MarkdownIt from "markdown-it";
import linkifyHtml from "linkify-html";
// Extensions
import { addModifyLinkExtension } from "./MdItModifyLinkExtension";
import { addOpenReferencePreviewModalOnLinkOverExtension } from "./MdItOpenReferencePreviewModalOnLinkOverExtension";

export class MarkdownItHelper {
    markdownIt: MarkdownIt;

    constructor() {
        this.markdownIt = MarkdownIt("commonmark")
            .disable(["code", "image"])
            .use(require("markdown-it-sub"))
            .use(require("markdown-it-sup"))
            .use(require("markdown-it-mark"));

        this.markdownIt.set({ html: false});
        // Add custom MarkdownIt extensions
        addModifyLinkExtension(this.markdownIt);
        addOpenReferencePreviewModalOnLinkOverExtension(this.markdownIt);
    }

    public render(source: string, env: any | undefined = undefined, doLinkify = false): string {
        if(!source) {
            source = "";
        }
        let renderedMarkdown = this.markdownIt.render(source, env);
        if(doLinkify) {
            renderedMarkdown = linkifyHtml(renderedMarkdown, {
                target: "_blank",
                attributes: {
                    rel: "noopener noreferrer"
                }
            });
        }

        return renderedMarkdown;
    }
}

export const MarkdownItHelperSingleton = new MarkdownItHelper();